import React from 'react'
import { CButton, CCol, CModal, CModalBody, CModalFooter, CRow } from '@coreui/react'

const ReviewLiveStreamModal = ({
  isEdit,
  onSave,
  name,
  description,
  location,
  recording,
  onBack,
}) => {
  return (
    <CModal
      size="lg"
      scrollable
      visible={true}
      alignment="center"
      className="custom-form-name-modal border-0"
    >
      <div
        className="px-5 text-white w-100 d-flex align-items-center"
        style={{ height: '3.8vw', backgroundImage: 'linear-gradient(to bottom, #646464, #111)' }}
      >
        <p style={{ fontSize: '1.5625vw' }} className="mb-0">
          Review your {isEdit ? '' : 'New'} Live Stream Setup
        </p>
      </div>
      <CModalBody className="px-5 py-4">
        <div className="w-100">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '14px' }}
            className="w-100 rounded pl-4"
          >
            Basic Information
          </div>
          <CRow className="pl-4 mt-3">
            <CCol lg={3}>
              <p style={{ fontSize: '12px' }}>Live Stream name</p>
            </CCol>
            <CCol lg={8}>
              <p style={{ fontSize: '12px' }}>{name}</p>
            </CCol>
          </CRow>
          <CRow className="pl-4">
            <CCol lg={3}>
              <p style={{ fontSize: '12px' }}>Description</p>
            </CCol>
            <CCol lg={8}>
              <p style={{ fontSize: '12px' }}>{description}</p>
            </CCol>
          </CRow>
        </div>
        <div className="w-100">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '14px' }}
            className="w-100 rounded pl-4"
          >
            Properties
          </div>
          <CRow className="pl-4 mt-3">
            <CCol lg={3}>
              <p style={{ fontSize: '12px' }}>Broadcast Location</p>
            </CCol>
            <CCol lg={8}>
              <p style={{ fontSize: '12px' }}>{location}</p>
            </CCol>
          </CRow>
          <CRow className="pl-4">
            <CCol lg={3}>
              <p style={{ fontSize: '12px' }}>Camera/Encoder</p>
            </CCol>
            <CCol lg={8}>
              <p style={{ fontSize: '12px' }}>RTMP</p>
            </CCol>
          </CRow>
          <CRow className="pl-4">
            <CCol lg={3}>
              <p style={{ fontSize: '12px' }}>Input Resolution</p>
            </CCol>
            <CCol lg={8}>
              <p style={{ fontSize: '12px' }}>1280 x 720</p>
            </CCol>
          </CRow>
          <CRow className="pl-4">
            <CCol lg={3}>
              <p style={{ fontSize: '12px' }}>Transcoding</p>
            </CCol>
            <CCol lg={8}>
              <p style={{ fontSize: '12px' }}>OTTDock Video</p>
            </CCol>
          </CRow>
          <CRow className="pl-4">
            <CCol lg={3}>
              <p style={{ fontSize: '12px' }}>Save to Asset manager</p>
            </CCol>
            <CCol lg={8}>
              <p style={{ fontSize: '12px' }}>{recording ? 'Yes' : 'No'}</p>
            </CCol>
          </CRow>
          <CRow className="pl-4">
            <CCol lg={3}>
              <p style={{ fontSize: '12px' }}>Delivery Protocol</p>
            </CCol>
            <CCol lg={8}>
              <p style={{ fontSize: '12px' }}>Apple HLS</p>
            </CCol>
          </CRow>
        </div>
      </CModalBody>
      <CModalFooter className="px-5 border-0">
        <CButton
          style={{ color: 'black', border: '1px solid black', fontSize: '.9vw' }}
          className="mx-4 bg-white rounded-1 btn-focus-none px-4"
          type="submit"
          onClick={onBack}
        >
          Back
        </CButton>
        <CButton
          style={{ border: '1px solid black', fontSize: '.9vw' }}
          className=" bg-black rounded-1 btn-focus-none px-4"
          type="submit"
          onClick={onSave}
        >
          {isEdit ? 'Update' : 'Create'}
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ReviewLiveStreamModal
